export default {
  Title: 'Hạch toán hóa đơn',
  Filter: 'Lọc hóa đơn',
  PeriodLabel: 'Chọn kỳ báo cáo',
  FromLabel: 'Từ ngày',
  ToLabel: 'Đến ngày',
  Organization: 'Nhà cung cấp',
  ObjectCode: 'Mã đối tượng',
  GetData: 'Lấy dữ liệu',
  PaymentMethod: 'Hình thức thanh toán',
  Cancel: 'Hủy bỏ',
  CreateAccountingVoucher: 'Sinh CT hạch toán',
  CreateDVCFile: 'Lập hồ sơ KBNN',
};